/* eslint-disable react/no-danger */

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestPrivacyPolicy } from '#/redux/modules/accedoOne/actions';
import { getPrivacyPolicy } from '#/redux/modules/accedoOne/selectors';

import parseTextForLinks from '#/utils/parseTextForLinks';
import { showConsentPreferences } from '#/services/consent/consent';
import styles from './PrivacyPolicy.scss';

export const PrivacyPolicy = () => {
  const dispatch = useDispatch();

  const privacyPolicyText = useSelector(state => getPrivacyPolicy(state));

  useEffect(() => {
    dispatch(requestPrivacyPolicy);
  }, []);

  return (
    <>
      <button
        type="button"
        className={styles.cookiePreferencesButton}
        onClick={showConsentPreferences}
      >
        Cookie preferences
      </button>
      <div
        dangerouslySetInnerHTML={{
          __html: privacyPolicyText && parseTextForLinks(privacyPolicyText),
        }}
        className={styles.privacyPolicyText}
      />
    </>
  );
};

PrivacyPolicy.propTypes = {};

export default PrivacyPolicy;
